import { CATALOG_METRICS } from 'modules/billing/constants';

const createDescriptionText = (metricType: string) =>
  `The number of ${metricType} references (counted by the number of handlebar references among all message sends).`;

export const CATALOG_CARD_IDS = {
  cardId: 'catalog-metrics',
};

export const CATALOG_CARD_TEXT = {
  cardTitle: 'Catalog',
  catalogCollectionDescription: createDescriptionText('catalog collection'),
  catalogCollectionName: 'Collection references',
  catalogLookupDescription: createDescriptionText('catalog'),
  catalogLookupName: 'Lookup references',
  productRecommendationName: 'Product recommendations',
  productRecommendationDescription: createDescriptionText('product recommendation'),
  projectBreakdownUrl: '/payments/info/catalogUsage',
};

export const CATALOG_METRIC_NAMES = [
  CATALOG_METRICS.catalogLookup,
  CATALOG_METRICS.catalogCollection,
  CATALOG_METRICS.productRecommendation,
];
